<div class="d-flex flex-column h-auto w-auto my-background">
  <!-- <div class="w-100 header d-flex justify-content-end">
    <button type="button" class="btn my-btn " routerLink="/">
      <mat-icon>home</mat-icon>
    </button>
    <button type="button" class="btn my-btn " (click)="logOut()" *ngIf="nom">
      <mat-icon>logout</mat-icon>
    </button>
  </div> -->
  <div class="d-flex small-font flex-grow-1">
    <div class="col-3 menu overflow-auto">
      <div class="container my-5" *ngIf="prenom">
        <div class="top-menu pt-5 d-flex align-items-center flex-column">
          <div class="txt-menu">Bonjour {{ prenom }}</div>
          <div>
            <span class="dateFormat">{{ today }}</span>
          </div>
        </div>

        <!-- <h5>Accueil</h5> -->
        <!-- <ul class="list-group">
          <li class="list-group-item"> <a class="accueil-link" routerLink="/">Mes tâches</a></li>
          <li class="list-group-item" *ngIf="accesVueTousUsers==1"> <a class="accueil-link" routerLink="/suivis/new"> 
            Missions suivie</a>
          </li>
        </ul> -->
        <ul class="list-group">
          <li class="list-group-item list-group-item-accueil d-flex align-items-center">
            <img class="menuPic" src="assets/img/menuPic/mesTaches.png" />
            <a class="accueil-link-white" routerLink="/">Mes tâches</a>
          </li>
          <li class="list-group-item list-group-item-accueil" *ngIf="accesVueTousUsers == 1">
            <img class="menuPic" src="assets/img/menuPic/missions.png" />
            <a class="accueil-link-white" routerLink="/suivis/new">Missions suivies</a>
          </li>
        </ul>

        <div class="row headerBox d-flex align-items-center">
          <img class="menuPic" src="assets/img/menuPic/eleves.png" />
          <h5>ÉLÈVES</h5>
        </div>
        <ul class="list-group ml-3">
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/rechercher.png" />
            <a class="eleves-link" routerLink="/student">Liste</a>
          </li>
          <!-- <li class="list-group-item"> <a class="eleves-link" routerLink="/student/etape"> Liste des étudiants/etapes</a></li> -->
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/ajouter.png" />
            <a class="eleves-link" routerLink="/student/new">Ajouter</a>
          </li>
        </ul>

        <!-- <h5>JPO</h5>
        <ul class="list-group">
          <li class="list-group-item"> <a class="jpo-link" routerLink="/jpo"> Liste des étudiants</a></li>
        </ul> -->

        <div class="row headerBox d-flex align-items-center">
          <img class="menuPic" src="assets/img/menuPic/entreprises.png" />
          <h5>ENTREPRISES</h5>
        </div>
        <ul class="list-group ml-3">
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/liste.png" />
            <a class="entreprises-link" routerLink="/entreprise">Liste</a>
          </li>
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/ajouter.png" />
            <a class="entreprises-link" routerLink="/entreprise/new">Ajouter</a>
          </li>
        </ul>

        <ng-container *ngIf="admin == '1'">
          <div class="row headerBox d-flex align-items-center">
            <img class="menuPic" src="assets/img/menuPic/entreprises.png" />
            <h5>ADMIN</h5>
          </div>
          <ul class="list-group ml-3">
            <li class="list-group-item">
              ✏️
              <a class="entreprises-link" routerLink="/admin/events">Evenements</a>
            </li>
            <li class="list-group-item">
              ✏️
              <a class="entreprises-link" routerLink="/admin">Modèle mail/whatsapp</a>
            </li>
          </ul>
        </ng-container>

        <!-- <div class="row headerBox d-flex align-items-center">
          <img class="menuPic" src="assets/img/menuPic/outils.png">
          <h5>OUTILS</h5>
        </div>
        <ul class="list-group ml-3">
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/tunnel.png">
            <a class="jpo-link" routerLink="/entreprise"> Tunnel de conv.</a>
          </li>
          <li class="list-group-item">
            <img class="menuPic" src="assets/img/menuPic/aideAuMatching.png">
            <a class="jpo-link" routerLink="/entreprise/new"> Aide au matching</a>
          </li>

        </ul> -->
      </div>

      <div class="container mt-4" *ngIf="!prenom">Bonjour Veuillez vous connecter</div>
    </div>

    <div class="col-9 flex-grow-1 ml-5 mr-4 w-auto my-background">
      <div class="header mt-3 d-flex justify-content-end">
        <button type="button" class="btn my-btn" routerLink="/">
          <mat-icon>home</mat-icon>
        </button>
        <button type="button" class="btn my-btn" (click)="logOut()" *ngIf="nom">
          <mat-icon>logout</mat-icon>
        </button>
      </div>
      <!-- contenenu de la page correspondant à l'url -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<!-- footer -->
